import ProductInfoRow from "../../ProductInfoRow";
import { Container } from "./_common";
import { StockDetails } from "../../StockDetails";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";

export default function TaskFormProduct({
  value: { productId, productType },
  conf: { withAvailability = false },
  disabled,
}) {
  const navigate = useFixaNavigate();
  const { data: itemInfo } = useItemInfo(productId);

  const showProductInfo = async () => {
    navigate(`/product/${itemInfo.type}${itemInfo.no}`);
  };

  const full_id = `${productType || ""}${productId || ""}`;
  const unitCode = "PIECES";
  return productId ? (
    <Container disabled={disabled} data-testid="product" tabIndex={0}>
      <ProductInfoRow art={productId} onClick={showProductInfo} imageLoader />
      {!!withAvailability && (
        <StockDetails full_id={full_id} unitCode={unitCode} />
      )}
    </Container>
  ) : null;
}
